import React from 'react';
import { Tag, Image } from 'antd';
import './style.scss';

const isCSAObject = (item) =>
    item &&
    typeof item === 'object' &&
    (item.articleName != null || item.barcodes != null || item.skuName != null);

const SupportArticleCartItems = ({ cart }) => {
    const rawItems = cart?.clientSupportingArticles?.length
        ? cart.clientSupportingArticles
        : cart?.items ?? [];
    const itemsAreIds = rawItems.length > 0 && !isCSAObject(rawItems[0]);
    const items = itemsAreIds ? [] : rawItems;
    const cartStatus = cart?.cartStage;

    const renderItem = (item) => {
        const name = isCSAObject(item)
            ? item.articleName ?? item.skuName ?? item._id ?? '—'
            : item.name ?? '—';
        const thumb = isCSAObject(item)
            ? item.articleImage?.thumbPath?.url ?? item.tagImage?.thumbPath?.url ?? null
            : null;
        const previewSrc = isCSAObject(item)
            ? item.articleImage?.imagePath?.url ?? item.tagImage?.imagePath?.url ?? thumb
            : thumb;
        const key = item._id ?? item.id;
        const status = item?.status ?? '—';
        const tagColor =
            status === 'returned' ? 'green' : status === 'issued' ? 'blue' : 'default';

        return (
            <div className="cart-item-row" key={key}>
                <div className="cart-item-thumb">
                    {thumb ? (
                        <Image
                            src={thumb}
                            alt=""
                            preview={{ src: previewSrc }}
                            className="cart-item-thumb-img"
                        />
                    ) : (
                        <div className="cart-item-thumb-placeholder" />
                    )}
                </div>
                <span className="item-name">{name}</span>
                <Tag color={tagColor} className="item-status-tag">
                    {status}
                </Tag>
            </div>
        );
    };

    if (cart?.clientSupportingArticles?.length && itemsAreIds) {
        return (
            <div className="support-article-cart-items-main">
                <div className="cart-items-header">
                    <h3 className="cart-items-title">{cart?.displayName}</h3>
                    {cartStatus && (
                        <Tag
                            color={cartStatus === 'Completed' || cartStatus === 'closed' ? 'green' : 'blue'}
                            className="cart-items-status-tag"
                        >
                            {cartStatus}
                        </Tag>
                    )}
                </div>
                <div className="cart-items-empty">Items not loaded.</div>
            </div>
        );
    }

    if (items.length === 0) {
        return (
            <div className="support-article-cart-items-main">
                <div className="cart-items-header">
                    <h3 className="cart-items-title">{cart?.displayName}</h3>
                    {cartStatus && (
                        <Tag
                            color={cartStatus === 'Completed' || cartStatus === 'closed' ? 'green' : 'blue'}
                            className="cart-items-status-tag"
                        >
                            {cartStatus}
                        </Tag>
                    )}
                </div>
                <div className="cart-items-empty">No items available for this cart.</div>
            </div>
        );
    }

    return (
        <div className="support-article-cart-items-main">
            <div className="cart-items-header">
                <h3 className="cart-items-title">{cart?.displayName}</h3>
                {cartStatus && (
                    <Tag
                        color={cartStatus === 'Completed' || cartStatus === 'closed' ? 'green' : 'blue'}
                        className="cart-items-status-tag"
                    >
                        {cartStatus}
                    </Tag>
                )}
            </div>
            <div className="cart-items-list">
                {items.map(renderItem)}
            </div>
        </div>
    );
};

export default SupportArticleCartItems;
